import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation, useParams } from "react-router-dom";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { useMst } from "@store/Route";
import { ChildType, ExistingParentType } from "@store/SchedulePermission";
import { isEmail, sleep } from "@utils/helper";
import { AlertError, AlertSuccess } from "@utils/alert";
import { color } from "@mui/system";
import { CircularProgress, colors } from "@mui/material";
import { toJS } from "mobx";
import BlackProfile from "@img/icons/blankProfile.png";

interface dataParent {
  dataInfo: ExistingParentType | null;
  // 0 not checking yet, 1 register, 2 not register, 3 error
  isRegistered: number;
  // 0 not saved, 1 saved, 2 error
  isSaved: number;
  email: string;
}

interface ParamTypes {
  id?: string;
}

const ShareChild = observer(() => {
  const history = useHistory();
  /* Getting the query string from the url. */
  const { id } = useParams<ParamTypes>();

  const { schedulePermissions, landing } = useMst();
  const { token } = landing;
  const {
    getListPermissionParent,
    fetchingListPermissionParent,
    checkExistingParent,
    addPermission,
    fetchRemovePermissionParent,
    removePermissionParent,
    existingParent,
    statusExistingParent,
    initialState,
    listPermissionParents,
    findChildById,
  } = schedulePermissions;

  // all in same index
  const [emails, setEmails] = useState<string[]>([""]);
  const [dataParent, setDataParent] = useState<dataParent[]>([
    { dataInfo: null, isRegistered: 0, isSaved: 0, email: "" },
  ]);
  const [indexFocus, setIndexFocus] = useState<number | null>(null);
  const [indexDelete, setIndexDelete] = useState<number | null>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [childDetail, setChildDetail] = useState<ChildType | null>(null);

  useLayoutEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (id) {
      setChildDetail(findChildById(parseInt(id, 10)));
    }
  }, [id]);

  const getData = useCallback(async () => {
    initialState();
    await sleep(1000);
    if (token && id) {
      getListPermissionParent(token, parseInt(id, 10));
    }
  }, [token, id]);

  useEffect(() => {
    let tempEmails = [...emails];

    let timerFunc = setTimeout(() => {
      const tempDataparent = [...dataParent];
      if (
        token &&
        indexFocus !== null &&
        tempEmails[indexFocus] !== "" &&
        tempDataparent[indexFocus].isSaved !== 1
      ) {
        checkExistingParent(token, tempEmails[indexFocus], (data) => {});
      }
    }, 500);
    return () => clearTimeout(timerFunc);
  }, [JSON.stringify(emails), indexFocus, token]);

  useEffect(() => {
    if (indexFocus !== null && indexFocus !== undefined) {
      const tempDataparent = [...dataParent];
      if (statusExistingParent === 404) {
        tempDataparent[indexFocus].isRegistered = 2;
        tempDataparent[indexFocus].email = emails[indexFocus];
      } else if (statusExistingParent !== 200) {
        tempDataparent[indexFocus].isRegistered = 3;
        tempDataparent[indexFocus].email = emails[indexFocus];
      } else if (existingParent) {
        tempDataparent[indexFocus].isRegistered = 1;
        tempDataparent[indexFocus].dataInfo = tempDataparent[indexFocus]
          .dataInfo?.permissionId
          ? tempDataparent[indexFocus].dataInfo
          : toJS(existingParent);
        tempDataparent[indexFocus].email = existingParent.user.email;
      }
      setDataParent(tempDataparent);
    }
  }, [existingParent, statusExistingParent, indexFocus]);

  /* set data parent existing  */
  const setInitialData = useCallback(async () => {
    await sleep(500);
    const listPermissionParentsTemp = toJS(listPermissionParents);
    let tempDataParent: dataParent[] = [];
    let tempEmails: string[] = [];
    if (listPermissionParentsTemp && listPermissionParentsTemp.length > 0) {
      for (let index = 0; index < listPermissionParentsTemp.length; index++) {
        const permissionParent = listPermissionParentsTemp[index];
        tempEmails.push(permissionParent.parent.email);
        tempDataParent.push({
          dataInfo: {
            id: permissionParent.parentId,
            permissionId: permissionParent.id,
            user: {
              email: permissionParent.parent.email,
              id: permissionParent.parent.id,
              mbcCustomerId: null,
            },
            salutation: null,
            firstName: permissionParent.parent.firstName,
            lastName: permissionParent.parent.lastName,
            securityCode: null,
            mobile: null,
            vaNumber: null,
            status: null,
            createdAt: permissionParent.createdAt,
            updatedAt: permissionParent.updatedAt,
          },
          isRegistered: 1,
          isSaved: 1,
          email: permissionParent.parent.email,
        });
      }
      setEmails([...tempEmails]);
      setDataParent([...tempDataParent]);
    } else {
      setDataParent([
        { dataInfo: null, isRegistered: 0, isSaved: 0, email: "" },
      ]);
      setEmails([""]);
    }
  }, [listPermissionParents]);

  useEffect(() => {
    setInitialData();
  }, [listPermissionParents]);

  const buttonSave = useCallback(async () => {
    // checking email
    let emailTemp = dataParent.filter((data) => !isEmail(data.email));
    if (emailTemp.length > 0) {
      AlertError("Email is not valid", `${emailTemp[0].email} is not valid`);
      setIsLoading(false);
      return;
    }

    // checking register email
    if (dataParent.filter((x) => x.isRegistered !== 1).length > 0) {
      AlertError("Email not Register", "Please Check Email");
      setIsLoading(false);
      return;
    }

    // post email
    let dataParentTamp = [...dataParent];
    dataParentTamp.forEach((data, index) => {
      if (
        id &&
        token &&
        data.dataInfo?.id &&
        (data.isSaved === 0 || data.isSaved === 2)
      ) {
        addPermission(token, data.dataInfo.id, parseInt(id, 10), (callback) => {
          if (callback === "error") {
            dataParentTamp[index].isSaved = 2;
          } else {
            dataParentTamp[index].isSaved = 1;
          }
        });
      }
    });

    if (dataParent.filter((data) => data.isSaved === 2).length > 0) {
      AlertError("Add Permission Faild", "Faild to add permission");
      setDataParent(dataParentTamp);
      setIsLoading(false);
      return;
    }

    await sleep(1500);

    AlertSuccess("Add Permission Success", "Success to add permission");
    setIndexFocus(null);
    setDataParent([...dataParentTamp]);
    setIsLoading(false);
    if (token && id) {
      getListPermissionParent(token, parseInt(id, 10));
    }
  }, [dataParent, isLoading]);

  const deletePermission = useCallback(
    (index: number) => {
      let dataParentTemp = [...dataParent];
      let emailsTemp = [...emails];
      setIndexDelete(index);
      setIndexFocus(null);
      if (
        dataParentTemp[index].isSaved === 0 ||
        dataParentTemp[index].isSaved === 2
      ) {
        dataParentTemp.splice(index, 1);
        emailsTemp.splice(index, 1);
        setDataParent([...dataParentTemp]);
        setEmails([...emailsTemp]);
        return;
      }
      const permissionId = dataParentTemp[index].dataInfo?.permissionId;
      if (token && permissionId && id) {
        removePermissionParent(token, parseInt(id, 10), permissionId, () => {
          AlertSuccess(
            "Remove Permission Success",
            "Success to remove permission"
          );
          dataParentTemp.splice(index, 1);
          emailsTemp.splice(index, 1);
          if (dataParentTemp.length === 0) {
            setDataParent([
              { dataInfo: null, isRegistered: 0, isSaved: 0, email: "" },
            ]);
            setEmails([""]);
            return;
          }
          setDataParent([...dataParentTemp]);
          setEmails([...emailsTemp]);
        });
      }
    },
    [dataParent]
  );

  /* Creating a callback function that will only be created if the dataParent object changes. */
  const onChangeText = useCallback(
    (text: string, index: number) => {
      let emailsTemp = [...emails];
      emailsTemp[index] = text;
      setEmails(emailsTemp);
      setIndexFocus(index);
    },
    [JSON.stringify(dataParent)]
  );

  /* A function that returns a Delete component. */
  const DeleteTextInput = useCallback(
    (index: number) => {
      if (fetchRemovePermissionParent === "pending" && index === indexDelete) {
        return (
          <CircularProgress
            style={{ color: colors.blue.A100, marginLeft: 10 }}
            size={20}
          ></CircularProgress>
        );
      }
      if (dataParent.length === 1 && dataParent[0].isSaved === 0) {
        return null;
      } else {
        return (
          <div
            className="formElements__floaterElement is--delete"
            onClick={() => {
              deletePermission(index);
            }}
          ></div>
        );
      }
    },
    [dataParent, fetchRemovePermissionParent, indexDelete]
  );

  return (
    <div>
      <div className="bg-white p-10 rounded-lg mt-6">
        <div className="flex flex-row items-center">
          <button
            className="w-1/12"
            onClick={() => {
              history.goBack();
            }}
          >
            <ArrowBackIcon fontSize="large" className="!text-5xl text-black" />
          </button>
          <h1 className="font-semibold w-11/12 text-black text-3xl">
            Manage Schedule Permission
          </h1>
        </div>

        <div className="flex flex-row mt-10">
          <img
            src={childDetail?.photoUrl || BlackProfile}
            className="rounded-full h-40 w-40"
          />
          <div className="w-full ml-10 flex flex-col">
            <h3 className="color--blue text-3xl font-semibold">
              {childDetail?.firstName || "" + " " + childDetail?.lastName || ""}
            </h3>
            <h3 className="mt-3 font-normal">{`Gender: ${childDetail?.gender}`}</h3>
            <h3 className="mt-3 font-normal">{`DOB: ${dayjs(
              childDetail?.dateOfBirth
            ).format("DD MMMM YYYY")}`}</h3>
          </div>
        </div>

        {fetchingListPermissionParent === "pending" ? (
          <div className="loaderWrapper">
            <div className="preloader preloaderBus" />
          </div>
        ) : (
          <>
            {dataParent.map((data, index) => {
              const isError =
                emails[index] !== "" &&
                dataParent[index]?.isRegistered &&
                (dataParent[index].isRegistered === 2 ||
                  dataParent[index].isRegistered === 3);
              return (
                <div key={`${index}`} className={"flex flex-col"}>
                  <div className="flex flex-row w-full mt-4">
                    <input
                      className={`!rounded-md border-solid border-2  ${
                        isError ? "!border-red-500" : "!border-gray-900"
                      }	 h-auto w-full px-4 py-4 text-black text-2xl`}
                      placeholder="Input Email"
                      required
                      type="email"
                      value={emails[index]}
                      onChange={(event) => {
                        onChangeText(event.target.value, index);
                      }}
                      disabled={data.isSaved === 1 ? true : false}
                    />
                    {DeleteTextInput(index)}
                  </div>
                  <div>
                    {isError ? (
                      <p className="mt-6 text-red-500">Email not found</p>
                    ) : null}
                    {dataParent[index]?.isSaved &&
                    dataParent[index].isSaved === 2 ? (
                      <p>Failed to Save</p>
                    ) : null}
                  </div>
                </div>
              );
            })}

            <div
              className="mt-10 font-semibold text-2xl cursor-pointer"
              onClick={() => {
                let dataParentTemp = [...dataParent];
                dataParentTemp.push({
                  dataInfo: null,
                  isRegistered: 0,
                  isSaved: 0,
                  email: "",
                });
                setDataParent(dataParentTemp);
                setEmails([...emails, ""]);
                setIndexFocus(null);
              }}
            >
              + Add Parent account email
            </div>

            <ButtonLoader
              isLoading={isLoading}
              className="w-2/12 mt-10"
              onClick={() => {
                setIsLoading(true);
                buttonSave();
              }}
            >
              Save
            </ButtonLoader>
          </>
        )}
      </div>
    </div>
  );
});

export default ShareChild;
